Ext.define('SA.view.sidebar.data.DataFacetAgeRange', {
    alias: 'widget.data-facet-age-range',
    extend: 'SA.view.sidebar.data.DataFacetRange',

    hidden: true,
    inputFormat: '%d',
    inputMask: /[\d]/,
    labelIncrement: 25,
    limits: [0, 100],
    maxValue: 100,
    stepIncrement: 1,
    tickIncrement: 12.5,
    title: 'Age Range'
});